import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProgressBar from './ProgressBar'; // Ensure this path is correct

function Checkout() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const bookingData = state || JSON.parse(sessionStorage.getItem('bookingData')) || {}; // Get from state or session
    const {
        adults, children, childAges, rooms, checkInDate, checkOutDate,
        calculatedPrice, specialRequests, arrivalTime,
        firstName, surname, email, phone, address, city, country, zip
    } = bookingData;

    if (Object.keys(bookingData).length === 0) {
        return <div>No checkout details provided.</div>;
    }

    const handleConfirm = () => {
        // Store booking data in session storage before navigation
        sessionStorage.setItem('confirmedBookingData', JSON.stringify(bookingData));
        navigate('/booking/confirmation');
    };

    const handleGoBack = () => {
        navigate('/booking/booking');
    };

    return (
        <div className="container mt-4">
            {/* Add the ProgressBar component here */}
            <ProgressBar currentStep={3} /> {/* Step 3 for Checkout */}

            <div className="card p-4 shadow">
                <h2 className="text-center mb-4">Checkout</h2>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <div className="checkout-details">
                            <h4 className="mb-3 text-center">Booking Summary</h4>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Name:</strong></div>
                                <div className="col-6 text-end">{firstName} {surname}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Email:</strong></div>
                                <div className="col-6 text-end">{email}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Phone:</strong></div>
                                <div className="col-6 text-end">{phone}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Address:</strong></div>
                                <div className="col-6 text-end">{address}, {city}, {country} - {zip}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Check In:</strong></div>
                                <div className="col-6 text-end">{checkInDate}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Check Out:</strong></div>
                                <div className="col-6 text-end">{checkOutDate}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Guests:</strong></div>
                                <div className="col-6 text-end">
                                    {adults} Adults, {children} Children ({childAges?.map((age, index) => (
                                        <span key={index}>{age} years old{index < childAges.length - 1 ? ', ' : ''}</span>
                                    ))})
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Total Price:</strong></div>
                                <div className="col-6 text-end">${calculatedPrice ? calculatedPrice.toFixed(2) : 'N/A'}</div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6"><strong>Number of Rooms:</strong></div>
                                <div className="col-6 text-end">{rooms}</div>
                            </div>
                            {specialRequests && (
                                <div className="row mb-2">
                                    <div className="col-6"><strong>Special Requests:</strong></div>
                                    <div className="col-6 text-end">{specialRequests}</div>
                                </div>
                            )}
                            {arrivalTime && (
                                <div className="row mb-2">
                                    <div className="col-6"><strong>Arrival Time:</strong></div>
                                    <div className="col-6 text-end">{arrivalTime}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12 d-flex justify-content-between">
                        <button className="btn btn-secondary" onClick={handleGoBack}>Go Back</button>
                        <button className="btn btn-primary" onClick={handleConfirm}>Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Checkout;